import React, { Component } from 'react';
import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { AccessoriesCart, ConfiguratorGroup, Footer, Header, SearchResults } from '.';
import { BusyContainer, ProductPrice, SvgImage,SuperCodeDisplay, Tab } from '../../../../components';
import { configuratorActions, getLanguages, translate, superCodeActions, flagActions, productActions } from '../../../../services';
import { ModelDebugViewer } from '..';
import DialogContainer from '../../../../components/DialogContainer';

import { 
  activeTabDispatcher, 
  analyticsDispatcher, 
  priceDispatcher,
  combineDispatchers, 
  combineStates, 
  productState, 
  screenState, 
  siteSettingsState, 
  superCodeDispatcher, 
  superCodeState,
  identityState,
  showConfigureDispatcher,
  showConfigureState,
  flagState,
  flagDispatcher,
  currentPageState,
  currentPageDispatcher,
  screenSizeState,
  productsDispatcher,
  priceState
} from '../../../../store';
import { 
  assignmentDecision,
  createCodeFromConfiguration,
  flattenTree,
  getAliases,
  isValidWithValidityInfo,
  showAccessoryForLanguage,
  translateProperty, 
  getAssignedValue,
  isRequiredAndUnselected,
  deflateModelVariables,
  TranslationService,
  getTranslationModelName,
  getConfigurationObject,
  getAccessoryAssignment,
  getProductDescription,
  PricingModule,
  showValueForLanguage,
  convertFGToLineItem} from '../../../../util';
import { AlignmentType } from '../../../../model';
import { CloseIconNew, CloseLightIconNew, EmptyStateIconNew, GreyFilterEmptyIconNew, NotSelectedRadioIconNew, SearchIconNew, SelectedRadioIconNew, WarningTriangleIconNew, arrowLeftIcon, caretDownIconNew, closePopup, listIcon4, newExpandButton, searchIcon } from '../../../../../style/images';
import { Box, Dialog, Tabs, IconButton as MuiIconButton, Button } from '@mui/material';
import { isBoolean } from 'lodash';
import { FGcomponent } from './FGcomponent';


export class ConfiguratorComponent extends Component {
  constructor() {
    super();
    this.state = {
      searchString: '',
      storedQueries: {},
      amounts: {},
      expanded: false,
      isReadyAssembled: false,
      showConfirmation: false,
      searchValue:"",
      searchActive:false,
      selectedProduct:"",
      hasGroupsResults: false,
      isExpanded: true,
      configurationUpdated: false,
      isConfigurationReset: false,
      selectedOption:"YES",
      tabSelected:""
    };
    this.setSelectedOption = this.setSelectedOption.bind(this);
    this.identifyConfiguration = this.identifyConfiguration.bind(this);
    this.handleTabSelected = this.handleTabSelected.bind(this);
  }

  componentDidMount(){
    const { assemblyType, configuration, user, siteSettings,superCodeSearchValue, oldProduct } = this.props;
    if( assemblyType == 'ReadyAssembled' && siteSettings.createSupercodeInSap ){
      this.setState( { isReadyAssembled: true } );
    }
    if( ( user.country.indexOf('CBOL') > -1 || user.country.indexOf('Cbol') > -1 || user.authenticationType == 'Apttus' ) && siteSettings.createSupercodeInSap ){
      this.setState( { isReadyAssembled: true } );
    }

    if(oldProduct?.isReadyAssembled){
      this.setState( { isReadyAssembled: true } );
    }
    if(oldProduct?.deliveryOption){
      this.setState({selectedOption:oldProduct?.deliveryOption});
    }
    
    { configuration && this.identifyConfiguration() }
    {superCodeSearchValue && configuration && this.identifyConfiguration() }
    if(this.props.currentPage.currentPage!=="configuratorPage" && !this.props.fromModelConfiguratorSelector){
      this.props.setPage("configuratorPage")
    }
  }

  componentWillReceiveProps(nextProps){
    const { configuration } = this.props;
    if( this.state.isReadyAssembled && configuration && configuration[0].productModelType !== 1 ){
      this.setState( { isReadyAssembled: false } );
    }
    if(nextProps.showConfigure.leave && !this.state.showConfirmation ) {
      this.setState({showConfirmation:true});
    }
  }

  updateHasGroupsResults(flag) {
    this.setState({hasGroupsResults: flag})
  }

  handleTabSelected(name){
    this.setState({tabSelected:name});
  }
  getChildContext() {
    return { 
      onAmountChange: ( amount, product ) => this.onAmountChange( amount, product._accessory )
    };
  }

  getTemplate( templateKey ){
    let firstTemplate = this.props.configuration[0].configuration.children.firstOrDefault();
    if( !firstTemplate  && this.props.configuration[0].materialKey==templateKey ){
      return this.props.configuration[0];
    } 
    if( !templateKey ){
      return this.props.configuration[0].configuration.children.length>0?this.props.configuration[0].configuration.children.firstOrDefault().childTemplate:this.props.configuration[0];
    }
    
//in case of service acc. model, children is empty so template to be taken from configuration
    //for models having children in configuration
    this.props.configuration.forEach(config=>{
      if(config.configuration?.children?.length>0){
        config.configuration.children.forEach(c=>{
          if(c.key===templateKey){
            firstTemplate=c;
            return firstTemplate.childTemplate
          }
        })
         //firstTemplate =  confg => confg.configuration.children.any( child => child.key === templateKey)

        //firstTemplate = this.props.configuration.firstOrDefault( confg => confg.configuration.children.any( child => child.key === templateKey)).configuration.children.firstOrDefault();
         //return firstTemplate.childTemplate
       // firstTemplate =  confg => confg.configuration.children.any( child => child.key === templateKey)
        //return firstTemplate.childTemplate;
      }
      ////for models not having children in configuration
      else if(config.configuration?.children.length==0){        if(config.materialKey ===templateKey){
          firstTemplate= config
        return firstTemplate;
        }

      }
      else if(!config.configuration){
        if( config.materialKey==templateKey)
        {
          firstTemplate= config
          return firstTemplate;
        }
      }
    })
    //firstTemplate = this.props.configuration.firstOrDefault( confg => confg.configuration.children.any( child => child.key === templateKey)).configuration.children.firstOrDefault();
    if(firstTemplate.childTemplate){
    return firstTemplate.childTemplate;
  }
    else{
      return firstTemplate;

 

    }
  }
  getAdditionalTemplate(){
    let additionalTemplate = this.props.configuration[1]?.configuration?.children.firstOrDefault();
    if( !additionalTemplate ){
      return this.props.configuration[1];
    }
    return this.props.configuration[1].configuration.children.firstOrDefault().childTemplate;
  }

  handleExpand(){
      this.setState({isExpanded:!this.state.isExpanded})
  }

  getTemplates(){
    const configurations = this.props.configuration;
    const templates = [];
    configurations.forEach( configuration => { 
      if( !configuration.configuration?.children.firstOrDefault() ){
        //Adding product name for non sap models
        //This is to avoid the error in the calling function
        let template = {...configuration, productName : configuration.product.name};
        templates.push( template )
        return templates;
      }
      let template = configuration.configuration.children.firstOrDefault().childTemplate;
      //Adding product name to the template. This is to identify the tempalte for Fixed part and Moving part
      //and to process it seperately for creating seperate supercodes
      template = {...template, productName : configuration.product.name}
      templates.push( template );
    });
    return templates;
  }
  getFilteredVariables( variables ) {
    const lang = getLanguages().first();
    const lowerSearchString = this.state.searchString.toLowerCase();

    return variables.filter( variable => {
      const name = variable.name.toLowerCase();
      const title = translateProperty( variable.properties, variable.title ).toLowerCase();

      return showAccessoryForLanguage( lang )( variable ) && 
             variable.show && 
             ( name.includes( lowerSearchString ) || title.includes( lowerSearchString ) || this.getFilteredValues( variable.values ).length > 0 );
    } );
  }

  getFilteredValues( values ) {
    const lang = getLanguages().first();
    const lowerSearchString = this.state.searchString.toLowerCase();

    return values.filter( value => {
      const name = value.name.toLowerCase();
      const title = translateProperty( value.properties, value.title ).toLowerCase();

      return showValueForLanguage( lang )( value ) && ( name.includes( lowerSearchString ) || title.includes( lowerSearchString ) );
    } );
  }

  getFilteredGroups( groups ) {
    const { isPopup } = this.props;
    const lowerSearchString = this.state.searchString.toLowerCase();

    return groups.filter( group => {
      const title = translateProperty( group.properties, group.title ).toLowerCase();

      return group.show && !( group.title === 'Selector' && isPopup ) &&
             ( title.includes( lowerSearchString ) || this.getFilteredVariables( group.variables ).length > 0 || group.hasChildren && this.getFilteredGroups( group.children ) );
    } );
  }

  sendAnalyticsQuery( query, model ) {
    const { storedQueries } = this.state;
    if ( !query ) {
      return;
    }
    const key = query.toLowerCase();
    if ( storedQueries[key] ) {
      // store query only once (this is per time the searchcomponent gets opened)
      return;
    }
    this.setState( { storedQueries: { ...storedQueries, [key]: true } },
      () => {this.props.captureEvent( 'search', 'search-accessories', query, ['commonTracker'] );
      const groups = this.getFilteredGroups( model.children );
    
      if( !groups || !groups.length ) {
        dataLayer.push({
          event: "search", 
          event_action:'search-accessories',
          event_label : query.concat(":search-config-accessories"),
          event_results : false,
          event_instance:this.props.siteSettings.properties.GaInstance,
          event_country: this.props.siteSettings.properties.GaCountry,
          location_url:window.location.href
        })   
      }
      else {
        dataLayer.push({
          event: "search", 
          event_action:'search-accessories',
          event_label : query.concat(":search-config-accessories"),
          event_results : true,
          event_instance:this.props.siteSettings.properties.GaInstance,
          event_country: this.props.siteSettings.properties.GaCountry,
          location_url:window.location.href
        })   
      
  }
      
    } );
  }

  getAccessories( lang, productModelType, productName ) {
    const templates = productName ? this.getTemplates().filter(t=>t.productName == productName) : this.getTemplates();
    let accessoriesCollection = [];
    templates.reduce( (accessoriesCollection, template) => {
      const accessory = template && ( deflateModelVariables( template.model ).filter( accessory => 
        assignmentDecision( productModelType, lang )( accessory ) && getAssignedValue( accessory ) !== template.product.materialNameLso 
      ));
      accessory && accessory.length > 0 && accessoriesCollection.push( ...accessory );
      const missingAccessoryAssignmentInBomComponents = accessory && accessory.length > 0 && template && template.bomComponents && accessory.findIndex(acc => !!acc && 
        template.bomComponents.findIndex(c => c.component===acc.assignedValue.name) === -1);
      if (template && template.bomComponents && ( template.bomComponents.length !== accessory.length || ( template.bomComponents.length === accessory.length && missingAccessoryAssignmentInBomComponents > 0 ) )) {
        accessoriesCollection.push( ...template.bomComponents.where( c => !!c && 
          accessory.findIndex(acc => acc.assignedValue.name ===c.component) === -1 )
          .select( c => ({
            assignedValue: {
              name: c.component
            }
        }) ));
      }
      return accessoriesCollection;
    }, accessoriesCollection );
    return accessoriesCollection;
  }
  
  // getUiGroups() {
  //   const template = this.getTemplate();
  //   return template && template.model.children;
  // }
  getUiGroups(){
    const configurations = this.props.configuration;
    const children = [];
    configurations.forEach( configuration => { 
      if( !configuration.configuration?.children.firstOrDefault() ){
//add materialkey in case of service acc model
        configuration.model.children[0].templateKey=configuration.configuration?.key || configuration.materialKey ;
        children.push( ...configuration.model.children )
        return children;
      }
      const template = configuration.configuration?.children.firstOrDefault().childTemplate;
      children.push(...template.model.children.map( child => {return { ...child, templateKey: template.materialKey, product:configuration.product.name } } ) );
    });
    if(this.props.configuration &&this.props.products && Object.keys(this.props.products).length > 0 && this.props.productsAvailable ){
      let productsToShow= this.props.products;
      this.props.configuration.forEach((configuration)=>{
        if( configuration && configuration.productModelType ==1 && configuration.configuration &&  configuration.configuration.children){
        configuration.configuration.children.forEach((child)=>{
      if(child.childTemplate && child.childTemplate.model && child.childTemplate.model.children){
        child.childTemplate.model.children.forEach((childModel)=>{
          if(childModel.variables){
            childModel.variables.forEach((variable)=>{
              if(variable.show){
                const isBOM=variable.properties && variable.properties.IsBomItem
                variable.values.forEach((value)=>{
                  if(value.title!='DO NOT DISPLAY'){
                  let ispresent=false;
                  if(productsToShow[value.name]){
                    ispresent =true;
                  }
                  if(!ispresent ){
                  //value.title=value.title?value.title:'DO NOT DISPLAY';
                  Object.keys(value.properties).map(key=>{
                    if(value.properties && value.properties[key]){
                      value.properties[key]='DO NOT DISPLAY'
                    }
                  })
                 }
                }
                })
              }
            })}
        })
      }
        })
        if(configuration.model.children){
        configuration.model.children.forEach((child)=>{
          if(child.variables){
            child.variables.forEach((variable)=>{
              if(variable.show){
                variable.values.forEach((value)=>{
                  if(value.title!='DO NOT DISPLAY'){
                  let ispresent=false;
                  if(productsToShow[value.name]){ 
                    ispresent =true;
                  }
                  if(!ispresent ){
                    //value.title=value.title?value.title:'DO NOT DISPLAY';
                    Object.keys(value.properties).map(key=>{
                    if(value.properties && value.properties[key]){
                      value.properties[key]='DO NOT DISPLAY'
                    }
                  })
                 }
                }
                })
              }
            })}
        })}
      }
      })
        }
    return children;
  }
  addClicked = (templateKey) => ( accessory, value, fqn, variable, index) => {
    this.onAmountChange( 1, accessory );
    return this.props.assignValue( this.getTemplate( templateKey ), accessory.name, value.name, fqn ).then(
      response => this.onConfigurationChange( response )
    );
  }

  removeClicked =( templateKey ) => ( accessory, value, fqn ) => {
    this.onAmountChange( 0, accessory );
    return this.props.removeValue( this.getTemplate( templateKey ), accessory.name, value.name, fqn || `${accessory.group}.${accessory.name}` ).then(
      response => this.onConfigurationChange( response )
    );
  }

  searchChanged = (e,model) => {
    const value = e && e.target && e.target.value && e.target.value.trim && e.target.value.trim();
    if (!value && !value.match) {
      return;
    }
    this.setState({searchValue:value});
    const searchString = value;
    this.isTyping && clearTimeout( this.isTyping );
    this.analyticsCache && clearTimeout( this.analyticsCache );
    
    this.isTyping = setTimeout( () => this.setState( { searchString } ), 500 );
    this.analyticsCache = setTimeout( () => this.sendAnalyticsQuery( searchString, model ), 1000 );
  }

  setTab = group => this.props.setTab( group, 'configurator' )
  
  makeSearchActive = ()=>{
    this.setState({searchActive:true})
  }

  makeSearchInactive = ()=>{
    let element = document.getElementById("configuratorSearch");
    document.getElementById("configuratorSearch").value = ""
    this.setState({searchActive:false, searchString: ''})
  }
  getTabs() {
    const { isPopup, siteSettings, configuration } = this.props;
    const { searchString } = this.state;
    const template = this.getTemplate();
    let additionalTemplate = {}
    if(this.props.configuration.length > 1){
      additionalTemplate = this.getAdditionalTemplate();
    }
    const { validityInfo } = template;
    const lang = getLanguages().first(); 
    const useModelName = configuration && configuration.length > 1;
    const translationService = TranslationService( getTranslationModelName( template ), 'model' )( lang );
    const groups = this.getUiGroups().map( translationService.withGroups.bind( translationService ) );
    const searchClass = this.state.searchActive?'configurator-search-active':'configurator-search'
    const tabs = [[
      // { 
      //   title: 'Debug Viewer', 
      //   isDisabled: !siteSettings.properties.isTestEnvironment,
      //   component: <ModelDebugViewer model={ template && template.model } /> 
      // },
      ...groups.map( group => {
        const showGroup = group && ( group.fullyQualifiedName === 'Selector' || group.fullyQualifiedName === 'GrpSelector' || group.fullyQualifiedName === 'General' || group.fullyQualifiedName === "Accessories" );
        return !group ? null : {
        isDisabled: !showGroup || configuration&&configuration.length>1&&configuration[1].materialKey.includes("ACC") && this.state.tabSelected!==group.fullyQualifiedName,
        title: translate( useModelName ? `${group.templateKey} Search`: 'Search accessories' ),
        product: group.product,
        component: <div className='configurator-search-panel' style={{height:this.state.searchActive?this.props.screenSize.width<=900?"100%":"calc(100% - 160px)":"max-content"}}>
          {/* <h3>{ translate( 'Search accessories' ) }</h3> */}
          <Box height="max-content" sx={{display:"flex", flexDirection:"row",
            width: {md:"100%",xs:"100vw"},
            padding: {md:"0 20px 0 16px",xs:"16px"},
            justifyContent: "space-between",
            alignItems: "center",
            margin:{md:"0px", xs:"-16px 0px"},
            borderBottom: {md:"0px", xs:"1px solid var(--primarrchy-color-grey-10, #EBEBEB)"},
            background: "#FFF",
            gap:{md:"0px", xs:"16px"}}}>
            <div className={searchClass}>
              <SvgImage className="search-icon" source={ SearchIconNew } />
              <input type='text' autoComplete="off" id="configuratorSearch" onKeyDown={(e) => {if(e.key === 'Enter') {e.target.blur();}}} onInput={(e)=>this.searchChanged(e,Object.keys(additionalTemplate).length > 0 && group.templateKey !== template.materialKey ? additionalTemplate.model : template.model)} onFocus={this.makeSearchActive} placeholder={ searchString!=="" || this.state.searchActive ?"":translate( this.state.tabSelected!=="Accessories"?'Search accessories by product name/code...':'Search loose accessories by product name/code...') } />
              {this.props.screenSize.width>900?<>{this.state.searchActive&&<div className='reset-icon'><SvgImage 
                source={ CloseLightIconNew } 
                onClick={ this.makeSearchInactive }
              /></div>}</>:<>{this.state.searchActive&&searchString!==""&&<div className='reset-icon'><SvgImage 
              source={ CloseLightIconNew } 
              onClick={ this.makeSearchInactive }
            /></div>}</>}
            </div>
            {this.state.searchActive&&<Box sx={{display:{md:"none", xs:"flex"}}}>
                <div className='tertiary-button' onClick={ this.makeSearchInactive } style={{width:"max-content", padding:"0px"}}><span>{ translate( 'Cancel' ) }</span></div>
              </Box>}
          </Box>
          {this.state.searchActive&&searchString===""?<div style={{width:"100%", height:"100%", display:"flex",flexDirection:"column",gap:"24px", justifyContent:"center", alignItems:"center"}}>
            <Box sx={{display:{md:"none", xs:"flex"},alignItems:"center",height:"60px", width:"60px"}}>
              <Box component="img" src={GreyFilterEmptyIconNew} sx={{height:"100%", width:"100%"}}></Box>
            </Box>
            <span className='start-search-type'>
              {translate("Start typing to find accessories by the product name or code")}
            </span>
          </div>:
          <SearchResults 
            model={ Object.keys(additionalTemplate).length > 0 && group.templateKey !== template.materialKey ? additionalTemplate.model : template.model }
            isPopup={ isPopup }
            goToGroup={ this.setTab } 
            searchString={ searchString }
            products = {this.props.products}
            assignValue={ this.addClicked(group.templateKey) }
            removeValue={ this.removeClicked(group.templateKey) }
            lang={ lang }
            siteSettings={this.props.siteSettings}
          />}
        </div>}
      }),
      ...!this.state.searchActive? groups.map( group => { 

        const variables = flattenTree(
          "children",
          "hasChildren",
          "variables"
        )(group);
        const hasError = variables.any(
          (variable) => !isValidWithValidityInfo(variable, validityInfo)
        );
     //start: new code added for CN accessory grouping
        const vari=[];
        group.variables.map( (variable) => {vari.push(variable);})

          function recLevel(le,node){
            node.properties= {Show: true, Name: node.GroupName , EN: '', ES: ''},
            node.show= true,
            node.title=node.GroupName;
            node.level=le;
            node.variables=[];
           if(node.SubGroup){
              le++;
              node.children=[];
              node.SubGroup.forEach((n)=>
                {
                 node.children.push(n)
                  n.parent=node.parent?node.parent+node.GroupName:node.GroupName; 
                  recLevel(le,n);
                }
                )
            }else if(node.Accessory){
              node.Accessory.forEach(
              (a)=>{vari.filter(v=>v.name===a).map((n)=>{
                  node.variables.push(n)})})
            }
            
           }
        var level=0;
        var ACCvar={}
        ACCvar=siteSettings.properties.AccessoryGrouping && siteSettings.properties.AccessoryGrouping[0][group.templateKey] ? siteSettings.properties.AccessoryGrouping[0][group.templateKey] :0;        
        ACCvar!=0 && ACCvar.forEach(n=>recLevel(level,n))
        if(ACCvar!=0){
          group.variables=[];
         group.children=ACCvar;
        }
        
         //END: new code added for CN accessory grouping
        // const variables = flattenTree( 'children', 'hasChildren', 'variables' )( group );
        // const hasError = variables.any( variable => !isValidWithValidityInfo( variable, validityInfo ) );

        return !group ? null : {
          isDisabled: !hasError && !group.show || group.title === 'Selector' && isPopup || !variables.any( showAccessoryForLanguage( lang ) ),
          title:translate( useModelName ? `${group.templateKey} ${group.title}`: group.title ),
          headerClassName: classNames( { 'required': group.variables.any( isRequiredAndUnselected ), 'error': hasError } ),
          fullyQualifiedName: group.fullyQualifiedName,
          product: group.product,
          setSelectedTab: this.handleTabSelected,
          component: <div class="configuratorgroup" style={{width:"100%", height:"100%", overflow:"auto"}}><ConfiguratorGroup
            variables={ group.variables }
            children={ group.children }
            lang={ lang }
            path={ group.fullyQualifiedName }
            selectorName={ configuration[0].newMaterialKey || configuration[0].materialKey }
            validityInfo={ validityInfo }
            onChange={ this.addClicked( group.templateKey ) }
            onRemove={ this.removeClicked( group.templateKey ) }
            fromModelConfiguratorSelector = {this.props.fromModelConfiguratorSelector}
            mainProductChanged = {this.props.mainProductChanged}
            selectedAccessorySelections = {this.props.selectedAccessorySelections}
            handleSelectedAccessorySelections = {this.props.handleSelectedAccessorySelections}
            configuration={this.props.configuration}
            templateKey={group.templateKey} 
            configurableProduct={configuration && configuration[0].product?.configurableProduct}
            bom={configuration && configuration[0]?.product?.bom}
          /></div>
        };
      } ):[],
    ]];
    return tabs; 
  }

  getCartProducts( accessories ) {
    const { amounts } = this.state;
    const { products } = this.props;

    return accessories
      .filter( accessory => products[accessory.assignedValue.name] && !products[accessory.assignedValue.name].obsolete )
      .map( accessory => {
        const product = Object.assign( {}, products[accessory.assignedValue.name] );
        product.amount = amounts[accessory.name] || 1;
        return product;
      } );
  }

  onAmountChange = ( amount, accessory ) => {
    if (!accessory) {
      return;
    }
    const amounts = Object.assign( {}, this.state.amounts, { [accessory.name]: amount } );
    this.setState( { amounts } );
  }

  toogleAccessoriesCart = () => {
    const { expanded } = this.state;
    this.setState( { expanded: !expanded } );
  }

  reset = () => this.props.resetConfigurator().then(
    response => this.onConfigurationChange( response, true )
  );

  identifyConfiguration = () => {
    let { configuration, superCodeSearchValue ,currentNode,user,prices} = this.props;
    superCodeSearchValue = "";
    const lang = getLanguages().first();
    let acc_list=[] //add accessories of both config
    let var_list=[] //add configuration to take details later
    configuration?.forEach(c => {
      const accessories = getAccessoryAssignment(this.getAccessories( lang, c.productModelType, c.product.name ));
     if(c.productModelType==1){
        acc_list.push(accessories)
        var_list.push(c)
        }
      
      else if(c.productModelType==0 ){
        if(c?.product?.configurableProduct && c.product.bom?.any(b=>accessories.any(acc=>acc.valueName==b.value))){

        if(accessories.length==1){
          acc_list.push(accessories)
          var_list.push(c)
        }
        else{
          const acc=accessories?.filter(acc=>c.product.bom.find(b=>acc.valueName==b.value))
          acc_list.push(acc)
          var_list.push(c)
        }}

        else{
          const acc=accessories?.filter(acc=>acc.variableName == "NEUTRO_EXT")
          acc_list.push(acc)
          var_list.push(c)
        }}   
    })
    const variantId = var_list[0].product.name;
    const variantKMAT=var_list[0].materialKey;//selector name
    const selectorAssignments = var_list[0].assignments;
    const accessories=acc_list[0];
    const accessoriesKMAT = var_list[0].configuration.children[0]?.key?var_list[0].configuration.children[0].key:var_list[0].configuration.key;//acc model name check
    const additionalVariantId=var_list[1]?.product.name; 
    const additional_acc=acc_list[1]?.map(acc=>{if(acc.variableName=="NEUTRO_EXT"){return {...acc,variableName:"Accessories.NEUTRO_EXT"}}else {return acc}})
    const additionalAssignments=additional_acc;  
    const additionalKMAT = var_list[1]?.materialKey;
    if( accessories.length ){
      //if( !this.checkAvailabilityOfSupercode( variantId, accessories )){
        this.props.identify( getConfigurationObject( accessories, variantId,additionalAssignments,
          additionalVariantId,variantKMAT,accessoriesKMAT,selectorAssignments,additionalKMAT) )
          .then((res)=>{
            if(res?.data?.superCodeLSO?.length>0){
              this.props.getProduct(res.data.superCodeLSO)
              .then((res)=>{
                if(res.product && !prices[res.product.name]){
                this.props.getPrices([convertFGToLineItem(res.product, user)])}
              })
              .catch(e=>console.log(e))}
            else if(additionalAssignments?.length>0) {
              this.props.identify( getConfigurationObject( accessories, variantId,[],'',
                variantKMAT,accessoriesKMAT,selectorAssignments,''))
                .then(res=>{
                  if(res?.data?.superCodeLSO?.length>0){
                     this.props.getProduct(res.data.superCodeLSO)
                    .then(res=>res.product && !prices[res.product.name] && this.props.getPrices([convertFGToLineItem(res.product, user)]))
                    .catch(e=>console.log(e))}}
                )
                .catch(e=>console.log(e)) 
            }})
          .catch(e=>console.log(e))
  }}

  checkAvailabilityOfSupercode = (variantId, accessories,accessoriesgeneralAssignment) => {
    const { superCode } = this.props;
    return superCode.items.find( item => item.variantId === variantId && 
      ((item.accessoriesAssignments?.length+item?.additionalAccessoryAssignment?.length) === accessories.length || ((item.accessoriesAssignments?.length) === accessoriesgeneralAssignment.length)  )
      && item.superCode.length>=12 && item.accessoriesAssignments.every(e => 
        accessories.any ( accessory => e.variableName === accessory.variableName && e.valueName == accessory.valueName))
    );
  }

  onConfigurationChange = ( configuredResponse, configurationReset=false ) => {
    this.props.updateConfigure(true);
    this.identifyConfiguration();
    if(configurationReset){
      this.setState( { configurationUpdated: true, isConfigurationReset: true } );
    }
    else{
      this.setState( { configurationUpdated: true, isConfigurationReset: false } );
    }
    return configuredResponse;
  }

  getSuperCode = (variantId, accessories, template,accessoriesgeneral=[]) => {
    const{superCodeSearchValue,superCode}= this.props;
    const accessoryAssignment = getAccessoryAssignment( accessories );
    const accessoriesgeneralAssignment = accessoriesgeneral && getAccessoryAssignment(accessoriesgeneral);
    let flag=false
    superCode.items.forEach((item)=>{
      if(item.variantId===variantId){
    let superCodeExisting=superCode.items.find( item => item.variantId === variantId && ((item.accessoriesAssignments?.length+item?.additionalAccessoryAssignment?.length) === accessoryAssignment.length || ((item.accessoriesAssignments?.length) === accessoriesgeneralAssignment.length)  )
           && item.accessoriesAssignments.every(e => 
            accessoryAssignment.any ( accessory => e.variableName === accessory.variableName && e.valueName == accessory.valueName))
        );
        if(superCodeExisting?.superCode){
          flag=true;
        }
      }
    });
    const superCodeObject = this.checkAvailabilityOfSupercode(
      variantId,
      accessoryAssignment,
      accessoriesgeneralAssignment
    );
    return superCodeObject
      ? superCodeObject.superCode
      : superCodeSearchValue && !flag
      ? superCodeSearchValue
      : "1SDX";
  };
  getFG=(product, Identifiedsupercode)=>{
    const{superCode}= this.props;
    const FG=superCode.items.find(item=>item.variantId===product.name && item.superCode==Identifiedsupercode)?.superCodeLSO
    return FG ? FG :"";}


  onAssemblyChanged = ( ) =>{
    const { user } = this.props;
    this.setState( { isReadyAssembled: !this.state.isReadyAssembled } );
    this.identifyConfiguration();
  }

  toggleConfirmation = (isInvalidAccessoriesSelected,accessoriesLength)=>{
    if(accessoriesLength === 0 || (isInvalidAccessoriesSelected && isBoolean(isInvalidAccessoriesSelected))){
      //if accessory not selected dont show confirmation popup
      this.props.hideConfigure()
    }else{
      //if accessory selected show confirmation popup
      this.setState({showConfirmation:!this.state.showConfirmation})
      this.props.showConfigure.leave && this.props.stayConfigurator()
    }
    //this.props.blurOnSearch.show && this.props.hideBlurOnSearch();
  }
  leaveConfigurator = ()=>{
    //this.props.blurOnSearch.show && this.props.hideBlurOnSearch();
    this.props.hideConfigure();
  }

  renderFooter = (isTopPosition, isPopup, productList, cartProducts, allMandatorySelectionsMade, 
    wiringDiagramDetailsCount, accessoriesLength, invalidVariables, requiredUnselectedVariables, 
    fromCart, oldProduct, template, assemblyType, supercode,supercodeAdditionalProduct, showConfiguratorButtonAtTop,configuration,accessories,inValidConfigurationMessage,isValidConfiguration) => {
    const customClassName = showConfiguratorButtonAtTop && isTopPosition ? 'configurator-subheader' : '';
    const FG_Identified=(this.state.configurationUpdated && !this.state.isConfigurationReset) || !configuration[0].product.FG?this.getFG(configuration[0].product,supercode):configuration[0].product.FG;
    const {fromSearch} = this.props;
    if((showConfiguratorButtonAtTop && isTopPosition) || (!showConfiguratorButtonAtTop && !isTopPosition)) {
      return <Footer 
        products={ isPopup ? productList : cartProducts } 
        isPopup={ isPopup } 
        isValid={this.props.fromModelConfiguratorSelector? true : allMandatorySelectionsMade && ( cartProducts.length + wiringDiagramDetailsCount ) === accessoriesLength }
        invalidVariables={ invalidVariables }
        requiredUnselectedVariables={ requiredUnselectedVariables }
        fromCart={ fromCart } 
        oldProduct={ oldProduct } 
        template={ template }
        customClassName={ customClassName }
        onAssemblyChanged = { this.onAssemblyChanged }
        isReadyAssembled = { this.state.isReadyAssembled }
        assemblyType = { assemblyType }
        hasAccessories = { accessoriesLength > 0 }
        supercodeIdentified= {(this.state.configurationUpdated && !this.state.isConfigurationReset)?supercode:configuration[0].product.superCode }
        supercodeAdditionalProduct = {supercodeAdditionalProduct}
        showConfiguratorButtonAtTop={showConfiguratorButtonAtTop}
        configuration={configuration}
        fromConfigurator
	      FG={FG_Identified}
        FGDescription={configuration[0]?.product?.code?.startsWith('V')?configuration[0]?.product?.description:this.props.products[FG_Identified]?.description}
        fromSearch={fromSearch}
        inValidConfigurationMessage={inValidConfigurationMessage}
        isValidConfiguration={isValidConfiguration}
        toggleConfirmation = {this.toggleConfirmation}
        fromModelConfiguratorSelector = {this.props.fromModelConfiguratorSelector}
        isEdit = {this.props.isEdit}
        selectedOption={this.state.selectedOption}
      />
    } else return '';
  }

  setCurrentProduct = product=>{
    this.setState({selectedProduct:product})
  }

  setSelectedOption = value=>{
    this.setState({selectedOption:value});
  }
  render() {
    const { user, className, configuration, fromCart, isPopup, oldProduct, screen, assemblyType, products , isEdit, siteSettings,selectorName} = this.props;
    const { expanded } = this.state;
    const { properties } = this.context;
    const apttusReconfig = user.authenticationType === 'Apttus' && user.properties["Action"] === "Reconfig";
    const fromCbol = user.authenticationType === 'Cbol';


    if(this.props.flags.showSearchOverlay){
       this.props.hideSearchOverlay();
    }
    if(configuration&&configuration.length>1&&!configuration[1].materialKey.includes("ACC")&&this.state.selectedProduct===""){
      this.setState({selectedProduct:configuration[0].product.name})
    }
    
    const {culture} = user;
    var Culture_lang='';
    if(culture.indexOf('-')>0){
      Culture_lang = culture.split( '-' )[0].toUpperCase();
    }
    if( !configuration ) {
      return <BusyContainer 
			actions={ 
				[
				  configuratorActions.ASSIGN,
				  configuratorActions.RESET,
				  configuratorActions.REMOVE,
				  configuratorActions.LOADED,
				  configuratorActions.FROMTEMPLATE,
				  superCodeActions.CREATE,
          flagActions.ADDING,
          'filter-active'
				]
			}><div className="abb-configurator" /></BusyContainer>;
    }
 const configurableProduct=configuration && configuration[0].product.configurableProduct

    const isValidBOM = configuration && configuration[0]?.productModelType === 1 && configuration[0].configuration?.children[0]?.childTemplate?.bomComponents != undefined;

    const wiringDiagramDetails = isValidBOM ? configuration[0].configuration.children[0].childTemplate.bomComponents.filter(wiringDiagram => Number(wiringDiagram.itemNumber) >= 9000 && !wiringDiagram.component.includes('1SDA'))
      : null;
    
    const template = this.getTemplate();
    let additionalTemplate = {}
    let allAccessoriesFromAdditionalProducts = {}
    let accessoriesFromAdditionalProducts = {}
    if(this.props.configuration.length > 1){
      additionalTemplate = this.getAdditionalTemplate();
    }
    const lang = getLanguages().first();
    const additionalProducts = configuration.slice( 1 ).map( conf =>{if(conf.configuration?.children.lenght>0){return { ...conf.product, configuration: conf.configuration?.children.firstOrDefault()?.childTemplate }}else{return{...conf.product, configuration: conf}}})
    const allAccessoriesFromConfig = this.getAccessories( lang, configuration[0].productModelType, configuration[0].product.name );
    if(this.props.configuration.length > 1){
      allAccessoriesFromAdditionalProducts = this.getAccessories( lang, configuration[1].productModelType, configuration[1].product.name );
    }
    
    
    const variables = deflateModelVariables( template.model );
    const tempRequiredUnselectedVariables = variables.filter( isRequiredAndUnselected );
    let reqAdditionalUnselectedVariables = {};
    //Adding the variables of moving part (additional product) to additionalVariables
    if(this.props.configuration.length > 1 && !configuration[1].materialKey.includes("ACC")){
      //const additionalTemplate = this.getAdditionalTemplate();
      const additionalVariables = deflateModelVariables( additionalTemplate.model );
      reqAdditionalUnselectedVariables = additionalVariables.filter(isRequiredAndUnselected);
    }
    const requiredUnselectedVariables = reqAdditionalUnselectedVariables.length > 0 ? [...tempRequiredUnselectedVariables, ...reqAdditionalUnselectedVariables] : [...tempRequiredUnselectedVariables];
    const invalidVariables = template.validityInfo && !template.validityInfo.isValid 
      ? template.validityInfo.invalidVariables.map( variable => variables.first( tmpVariable => tmpVariable.name === variable.name ) )
      : [];
    const isValidConfiguration=  template.validityInfo && template.validityInfo.isValid;
    const inValidConfigurationMessage=template.validityInfo && template.validityInfo.message;
    const allMandatorySelectionsMade = requiredUnselectedVariables.length > 0 ? false : true;
    let accessories = !allMandatorySelectionsMade && wiringDiagramDetails 
      ? allAccessoriesFromConfig.filter( acc => { return wiringDiagramDetails.findIndex( wdd => wdd.component === acc.assignedValue.name ) === -1 && acc })
      : allAccessoriesFromConfig;
    //Adding accessories of moving part to accessoriesFromAdditionalProducts
    if(this.props.configuration.length > 1){
      accessoriesFromAdditionalProducts = !allMandatorySelectionsMade && wiringDiagramDetails 
      ? allAccessoriesFromAdditionalProducts.filter( acc => { return wiringDiagramDetails.findIndex( wdd => wdd.component === acc.assignedValue.name ) === -1 && acc })
      : allAccessoriesFromAdditionalProducts;
    }
    const total_accessories= accessoriesFromAdditionalProducts.length>0? accessories.concat(accessoriesFromAdditionalProducts.filter(acc=>acc.name=='NEUTRO_EXT')):accessories;
    //fetching the supercode for moving part and fixed part before merging accessories from Moving and fixed part
    const supercode = this.getSuperCode( configuration[0].product.name, total_accessories, template,accessories );

    const supercodeAdditionalProduct =  this.props.configuration.length > 1 && this.getSuperCode( configuration[1].product.name, accessoriesFromAdditionalProducts, additionalTemplate,accessories ); 
    //Merging accessories of moving and Fixed part if fixed part is there in the configuration

    const FG_Identified=(this.state.configurationUpdated && !this.state.isConfigurationReset) || !configuration[0].product.FG?this.getFG(configuration[0].product,supercode):configuration[0].product.FG;

    if (
      this.props.configuration.length > 1 && 
      accessoriesFromAdditionalProducts.length > 0
    ) {
      accessories.push(
        ...accessoriesFromAdditionalProducts.map((acc) => {
          return acc;
        })
      );
      accessories && accessories.forEach((val,idx)=>{val.bom=configuration && configuration[0].product.bom && configuration[0].product.bom.find(b=>b.name==val.assignedValue?.name)})
    }
    const wiringDiagramDetailsCount = wiringDiagramDetails && wiringDiagramDetails.length;
    let cartProducts = this.getCartProducts( accessories );
    
    const showConfiguratorButtonAtTop = this.props.siteSettings.properties.showConfiguratorButtonAtTop;
    const customClassName = showConfiguratorButtonAtTop ? 'border-none' : '';
     //Phase3 Hiding Accessories change
     const hideAccFlag = siteSettings?.properties?.HideAccessories;
     const fixedVariables =  hideAccFlag && hideAccFlag.find(sel => sel.selectorName == selectorName)?.retrofitVariables; //From sitesettings: It has the selector variables for which accessories need to be hidden based on condition
     const retrofitAssignments = configuration.map(item => item.product.filterSelectors);
     let retrofitVariables = configuration[0].configuration?.children[0]?.childTemplate?.model?.children[0]?.variables;
     let selectedValue = "";
     if(hideAccFlag){
       if(hideAccFlag.find(selector => selector.selectorName == selectorName)){
         fixedVariables.length>0?fixedVariables.forEach(variable => {
           const firstItem = retrofitAssignments[0].find(item => 
             {
             return item?.fullyQualifiedName?.substring(9,) === variable});
         
           if(!!firstItem)
           { selectedValue = firstItem.values.find(value => value.isAssignable && value.isSelected).name }  
           else
           {
             selectedValue = undefined;
           }
         hideAccFlag.find(sel => sel.selectorName == selectorName && sel.SapAccHide?.forEach(hideVar => {
           let variableToHide = retrofitVariables.find(val => val.name == hideVar.Sapacc_var); //Hiding based on condition
           if (variableToHide) {
             if(Array.isArray(hideVar.Sapacc_cond)){
               if(hideVar.Sapacc_cond.any(acc=>acc==selectedValue)){
                 variableToHide.show = false;
                 variableToHide.hidden=true;
                 return variableToHide.show;
               }
             }
             else{
             if (hideVar.Sapacc_cond == selectedValue) {
               variableToHide.show = false;
               variableToHide.hidden=true;
               return variableToHide.show;
           }
           else if (hideVar.Sapacc_cond == "") {
             variableToHide.show = false;
             variableToHide.hidden=true;
             return variableToHide.show;
           }}
         }
       }))}):
       hideAccFlag.find(sel => sel.selectorName == selectorName && sel.SapAccHide?.forEach(hideVar => {
         let variableToHide = retrofitVariables.find(val => val.name == hideVar.Sapacc_var); //Hiding based on condition
         if (variableToHide) {
           if(Array.isArray(hideVar.Sapacc_cond)){
             if(hideVar.Sapacc_cond.any(acc=>acc==selectedValue)){
               variableToHide.show = false;
               variableToHide.hidden=true;
               return variableToHide.show;
             }
           }
           else{
           if (hideVar.Sapacc_cond == selectedValue) {
             variableToHide.show = false;
             variableToHide.hidden=true;
             return variableToHide.show;
         }
         else if (hideVar.Sapacc_cond == "") {
           variableToHide.show = false;
           variableToHide.hidden=true;
           return variableToHide.show;
         }}
       }
     }));
      
     }
   }
   const tabs = this.getTabs(); //load the configurator after object is updated else can miss the hiding accessories DEV-1841
   
   //flag to check if both general and looseaccessories tab has to be shown
   const requiredTabHeaders = ["General", "Accessories"];
   const requiredTabs = tabs[0].filter(tab=>tab.fullyQualifiedName && requiredTabHeaders.includes(tab.fullyQualifiedName))
   
   // this will be all the other options other than dropdowns for example- model search bar.
   let newTabs = [...tabs];
   if(requiredTabs.length>1){
     newTabs[0] = newTabs[0].filter(tab=> !requiredTabHeaders.includes(tab.fullyQualifiedName))
   }

   if(configuration)
    if( properties && properties.orderCodeAvailable ) {
      configuration.product.aliases = getAliases( createCodeFromConfiguration( variables, properties ) );
    }
    //const additionalProducts = configuration.slice( 1 ).map( conf => { return { ...conf.product, configuration: conf.configuration.children.firstOrDefault().childTemplate }})
    const productList = {...configuration[0].product, additionalProducts:[...additionalProducts ]};
    
    const mobileHeader = {
      isDisabled:this.state.searchActive,
      component:<div className='double-header-column'>
    <h6>
      {`${translate("Configure")}: 2 ${translate("products")}`}
    </h6>
    {configuration.map((configuration)=>{
      return <div className='product-header'>
      { this.state.selectedProduct !== configuration.product.code  ? <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={()=>{this.setCurrentProduct(configuration.product.name)} }>
        <Box component="img" sx={{width:"16px",height:"16px"}} src={NotSelectedRadioIconNew}></Box>
      </MuiIconButton> 
      :<MuiIconButton disableFocusRipple disableRipple disableTouchRipple>
        <Box component="img" sx={{width:"16px",height:"16px"}} src={SelectedRadioIconNew}></Box>
      </MuiIconButton> }
      <div className='product'>
        <span className='product-name'>
          {configuration.product.code}
          </span>
          <span className='product-description'>
            {configuration.product.description}
          </span>
      </div>
      </div>
    })}
  </div>}
    const mobileTabs = [
      [
        {
          title: 'Configure',
          component: configuration.length>1 && !configuration[1].materialKey.includes("ACC") ?<div style={{width:"100%", height:"100%",display:"flex", flexDirection:"column", gap:"16px"}}>
              {[...tabs[0].filter(tab=>tab.product===this.state.selectedProduct).slice(0, 1),mobileHeader, ...tabs[0].filter(tab=>tab.product===this.state.selectedProduct).slice(1)].map(tab=>!tab.isDisabled&&tab.component)}
            </div>:<>{
            requiredTabs.length>1?<>
              {newTabs[0].map(tab=>!tab.isDisabled&&tab.component)}
              <Tab  additionalClass={"requiredTabs"} tabs={[requiredTabs]}/></>
              :
              tabs[0].map(tab=>!tab.isDisabled&&tab.component)}</>,
          properties: this.props,
        },
        {
          title: 'Selected Products',
          component: 
          <div style={{display:"flex", width:"100%", height:"100%", overflow:"auto", background: "#F5F5F5"}}>
          <div style={{display:"flex", flexDirection:"column", width:"100%", height:accessories.length>0?"max-content":"100%", background: "#F5F5F5"}}>
          <AccessoriesCart
          configuration = {configuration} 
          accessories={accessories}
          accessoriesFromAdditionalProducts = {accessoriesFromAdditionalProducts}
          isPopup={ isPopup } 
          language={ lang } 
          onAmountChange={ this.onAmountChange } 
          validityInfo={ template.validityInfo } 
          resetConfigurator={ this.reset }
          // onRemove={ this.removeClicked( group.templateKey ) }
          allMandatorySelectionsMade={ allMandatorySelectionsMade }
          wiringDiagramDetails ={wiringDiagramDetails}
          translationPhrase={'Total_'}
          showConfiguratorButtonAtTop={showConfiguratorButtonAtTop}
          NSTbom_ACC={configuration[0].product.bom}
          fromConfigFooter 
          fromCart = { false || fromCbol || apttusReconfig } 
          priceSize='big' 
          product={ { ...productList, configuration: template,FG:FG_Identified } }
          fromSearch={this.props.fromSearch}
        /></div></div>,
          properties: this.props,
          accessories: accessories ,
          accessoriesFromAdditionalProducts : accessoriesFromAdditionalProducts,
          mobileTab : true
        },
      ]
    ]

    let selected = configuration.find(c=>c.product.code===this.state.selectedProduct);

    if(this.props.fromModelConfiguratorSelector){
      if(this.props.showOnlySelectors){
        return <>{tabs[0].map(tab=>!tab.isDisabled&& tab.title!=="Search accessories" &&
        <><div class="separator"></div>
         <div className='add-ons-container '>
        <span className="add-ons-heading-container">
          <span className='add-ons-headings'>
            <SvgImage source={ newExpandButton } className={classNames("expander-icon",{'expanded':this.state.isExpanded})} onClick={()=>{this.handleExpand()}}></SvgImage>
            {tab.title}</span>
        </span>
        {this.state.isExpanded && tab.component}</div></>)}</>
      }
      else if(this.props.showOnlyAccessoriesList){
        return <AccessoriesCart 
        accessories={ accessories }
        isPopup={ isPopup } 
        language={ lang } 
        onAmountChange={ this.onAmountChange } 
        validityInfo={ template.validityInfo }
        resetConfigurator={ this.reset } 
        configuration = {configuration}
        onRemove={ this.removeClicked( this.state.currentGroup ) }
        allMandatorySelectionsMade={ allMandatorySelectionsMade }
        wiringDiagramDetails ={wiringDiagramDetails}
        translationPhrase={'Total_'} showConfiguratorButtonAtTop={showConfiguratorButtonAtTop} fromConfigFooter fromCart = { false || fromCbol || apttusReconfig } priceSize='big' product={ { ...productList, configuration: template } }
        view = {"modelconfiguratorproduct"}
        fromModelConfiguratorSelector
        NSTbom_ACC={configuration[0].product.bom}
        FG={(this.state.configurationUpdated && !this.state.isConfigurationReset)|| !configuration[0].product.FG?this.getFG(configuration[0].product,supercode):configuration[0].product.FG}
        fromSearch={this.props.fromSearch}
        FGDescription={configuration[0]?.product?.code?.startsWith('V')?configuration[0]?.product?.description:this.props.products[(this.state.configurationUpdated && !this.state.isConfigurationReset) || !configuration[0].product.FG?this.getFG(configuration[0].product,supercode):configuration[0].product.FG]?.description}
        productList={ isPopup ? productList : cartProducts } 
        template = {template}
      />
      }
      cartProducts = [{...configuration[0].product, hideConfigureButton:true}, ...cartProducts];
      return this.renderFooter(false, false, productList, cartProducts, allMandatorySelectionsMade, 
        wiringDiagramDetailsCount, accessories.length, invalidVariables, requiredUnselectedVariables, 
        fromCart, oldProduct, template, assemblyType, supercode,supercodeAdditionalProduct, showConfiguratorButtonAtTop,configuration,accessories,inValidConfigurationMessage,isValidConfiguration)
    }
   const isValid=this.props.fromModelConfiguratorSelector? true : allMandatorySelectionsMade && ( cartProducts.length + wiringDiagramDetailsCount ) === accessories.length ;
    const isInvalidAccessoriesSelected = !isValid || invalidVariables.length > 0 || requiredUnselectedVariables.length > 0;
    return<>
     <div className={ classNames( 'abb-configurator', className, { 'expanded': expanded } ) }>
      {/* { isPopup && configuration[0].product.description && 
		<Header product={ configuration[0].product } additionalProduct={additionalProducts[0]} properties={ properties }
		  variables={ variables } 
      customClassName={ customClassName }
      supercode= { supercode }
      supercodeAdditionalProduct = {supercodeAdditionalProduct}
      isReadyAssembled = { this.state.isReadyAssembled }
      productModelType = { configuration.productModelType }
      showConfiguratorButtonAtTop={showConfiguratorButtonAtTop}
		/> } */}
    {this.renderFooter(true, isPopup, productList, cartProducts, allMandatorySelectionsMade, 
    wiringDiagramDetailsCount, accessories.length, invalidVariables, requiredUnselectedVariables, 
    fromCart, oldProduct, template, assemblyType, supercode, supercodeAdditionalProduct, showConfiguratorButtonAtTop,configuration,accessories,inValidConfigurationMessage,isValidConfiguration)}
      <div className="configurator-content">
        <Box width="100%" height="100%" sx={{display:{md:"flex", xs:"none"}}}>
        <BusyContainer 
			className={classNames("configurator-selection-panel", {"fullScrollable":this.props.screenSize.height<=900})}
			actions={ 
				[
				  configuratorActions.ASSIGN,
				  configuratorActions.RESET,
				  configuratorActions.REMOVE,
				  configuratorActions.LOADED,
				  configuratorActions.FROMTEMPLATE,
				  superCodeActions.CREATE,
          productActions.GET,
          productActions.LOAD,
          flagActions.ADDING,
          'filter-active'
				]
			} 
      // isBusy={this.props.isBusy}
			>
        
          <div className='configurator-selection-panel-header'>
          {!isEdit && <div className="back-button" onClick={ ()=>{this.toggleConfirmation(isInvalidAccessoriesSelected,accessories.length)} } title={ translate( 'Go back' ) }>
              <Box className="back-button-arrow" component="img" src={arrowLeftIcon} ></Box>
              <span>{ translate( 'Back' ) }</span>
            </div>}
            { configuration.length>1 && !configuration[1].materialKey.includes("ACC")?
             <div className='double-header-column'>
              <h6>
                {`${translate("Configure")}: 2 ${translate("products")}`}
              </h6>
              {configuration.map((configuration)=>{
                return <div className='product-header'>
                { this.state.selectedProduct !== configuration.product.code  ? <MuiIconButton onClick={()=>{this.setCurrentProduct(configuration.product.name)} }>
                  <Box component="img" sx={{width:"16px",height:"16px"}} src={NotSelectedRadioIconNew}></Box>
                </MuiIconButton> 
                :<MuiIconButton disableFocusRipple disableRipple disableTouchRipple>
                  <Box component="img" sx={{width:"16px",height:"16px"}} src={SelectedRadioIconNew}></Box>
                </MuiIconButton> }
                <div className='product'>
                  <span className='product-name'>
                    {configuration.product.code}
                    </span>
                    <span className='product-description'>
                      {configuration.product.description}
                    </span>
                </div>
                </div>
              })}
            </div>
            :
              <div className='header-column'>
              <h6>
                {`${translate("Configure")}: `}
                <span>{`${configuration[0].product.name}`}</span>
              </h6>
              {/* <span>
                {configuration[0].product.description}
              </span> */}
              <span title = { getProductDescription(configuration[0].product,Culture_lang) }>{ getProductDescription(configuration[0].product,Culture_lang) }</span>
            </div>
            }
            { this.state.isReadyAssembled && 
             <span>
              <SuperCodeDisplay isReadyAssembled= { this.state.isReadyAssembled } supercode = { supercodeAdditionalProduct ? supercode + ' + ' + supercodeAdditionalProduct: supercode } supercodeAdditionalProduct = {supercodeAdditionalProduct}/>
            </span>}
            {PricingModule.showPrice( siteSettings.pricingModule ) && <div className='price-column'>
              {configuration.length>1 && !configuration[1].materialKey.includes("ACC")?
              <div className='row'>
                <span>{translate("Main breaker price")}:</span>
                {/* <ProductPrice translationPhrase={'Total_'}fromConfigFooter fromCart = { false || fromCbol || apttusReconfig } priceSize='big' product={{ ...productList, configuration: template }} /> */}
                <ProductPrice  fromCart = { false || fromCbol || apttusReconfig } priceSize='big' product={{...selected?.product}} />
              </div>
              :
              <div className='row'>
                <span>{translate("Main breaker price")}:</span>
                {/* <ProductPrice translationPhrase={'Total_'}fromConfigFooter fromCart = { false || fromCbol || apttusReconfig } priceSize='big' product={{ ...productList, configuration: template }} /> */}
                <ProductPrice  fromCart = { false || fromCbol || apttusReconfig } priceSize='big' product={{ ...productList}} />
              </div>
                } 
            </div>}
          </div>
          <Box width="100%" border="1px solid #EBEBEB"></Box>
          {/* <Tab header={ translate( 'Characteristics' ) } alignment={ AlignmentType.vertical } tabs={ tabs } title="configurator"/> */}
          {/* <Tab alignment={ AlignmentType.vertical } tabs={ tabs } title="configurator"/> */}
          {configuration.length>1 && !configuration[1].materialKey.includes("ACC")?<>
            {tabs[0].filter(tab=>tab.product===this.state.selectedProduct).map(tab=>!tab.isDisabled&&tab.component)}
          </>:
            <>{
            requiredTabs.length>1?<>
              {newTabs[0].map(tab=>!tab.isDisabled&&tab.component)}
              <Tab  additionalClass={"requiredTabs"} tabs={[requiredTabs]}/></>
              :
              tabs[0].map(tab=>!tab.isDisabled&&tab.component)}</>
          }
        </BusyContainer>
        { 
          ( screen.isMobile || screen.isTablet ) &&   
          <div className="expand-panel">
            <SvgImage 
              source={ listIcon4 } 
              onClick={ this.toogleAccessoriesCart } 
              toolTip={ translate( '{action} selected Accessories:', { action: expanded ? 'Hide' : 'Show' } ) }
            />
          </div>
        }
        <div style={{display:"flex",flexDirection:"column", width:"70%", height:"100%", overflow:"auto", background: "#F5F5F5", justifyContent:"space-between"}}>
          <div style={{display:"flex", flexDirection:"column", width:"100%", height:`calc(100% - 44px)`, background: "#F5F5F5"}}>
            {!this.props.isBusy &&  <AccessoriesCart 
              accessories={ accessories }
              isPopup={ isPopup } 
              language={ lang } 
              onAmountChange={ this.onAmountChange } 
              validityInfo={ template.validityInfo }
              resetConfigurator={ this.reset } 
              configuration = {configuration}
              onRemove={ this.removeClicked( this.state.currentGroup ) }
              allMandatorySelectionsMade={ allMandatorySelectionsMade }
              wiringDiagramDetails ={wiringDiagramDetails}
              NSTbom_ACC={configuration[0].product.bom}
              translationPhrase={'Total_'}
              showConfiguratorButtonAtTop={showConfiguratorButtonAtTop}
              fromConfigFooter 
              fromCart = { false || fromCbol || apttusReconfig } 
              priceSize='big' 
              product={ { ...productList, configuration: template,FG: FG_Identified} }
              fromSearch={this.props.fromSearch}
            
            />}
            {configuration.length>1 && !configuration[1].materialKey.includes("ACC")&&<AccessoriesCart 
              accessories={ accessoriesFromAdditionalProducts}
              extraAccessories = {true}
              isPopup={ isPopup } 
              language={ lang } 
              onAmountChange={ this.onAmountChange } 
              validityInfo={ template.validityInfo } 
              resetConfigurator={ this.reset } 
              configuration = {configuration}
              onRemove={ this.removeClicked( this.state.currentGroup ) }
              allMandatorySelectionsMade={ allMandatorySelectionsMade }
              wiringDiagramDetails ={wiringDiagramDetails}
              NSTbom_ACC={configuration[0].product.bom}
              translationPhrase={'Total_'}
              howConfiguratorButtonAtTop={showConfiguratorButtonAtTop} 
              fromConfigFooter 
              fromCart = { false || fromCbol || apttusReconfig } 
              priceSize='big' 
              product={ { ...productList, configuration: template, FG:FG_Identified } }
              fromSearch={this.props.fromSearch}
              
            />}
          </div>
        
          <FGcomponent
        FGDescription={configuration[0]?.product?.code?.startsWith('V')?configuration[0]?.product?.description:this.props.products[(this.state.configurationUpdated && !this.state.isConfigurationReset)|| !configuration[0].product.FG?this.getFG(configuration[0].product,supercode):configuration[0].product.FG]?.description}
        FG={(this.state.configurationUpdated && !this.state.isConfigurationReset) || !configuration[0].product.FG?this.getFG(configuration[0].product,supercode):configuration[0].product.FG}
          showConfiguratorButtonAtTop={showConfiguratorButtonAtTop}
          user={this.props.user}
          isPopup={isPopup}
          template={template}
          products={ isPopup ? productList : cartProducts } 
          fromSearch={this.props.fromSearch}
        selectedOption={oldProduct?.deliveryOption || this.state.selectedOption}
          setSelectedOption = {this.setSelectedOption}
          />    
        </div>
        </Box>
        <Box height="100%" width="100%" sx={{display:{md:"none", xs:"flex"}, flexDirection:"column"}}>
            <BusyContainer 
          className="configurator-selection-panel" 
          actions={ 
            [
              configuratorActions.ASSIGN,
              configuratorActions.RESET,
              configuratorActions.REMOVE,
              configuratorActions.LOADED,
              configuratorActions.FROMTEMPLATE,
              superCodeActions.CREATE,
              'filter-active'
            ]
          }>
            <div className='configurator-selection-panel-header'>
              <div className='back-button'>
                <Box className='back-button-arrow' component="img" src={arrowLeftIcon} onClick={()=>{this.toggleConfirmation(isInvalidAccessoriesSelected,accessories.length)}}></Box>
              </div>
              <div className='header-column'>
                <h6>
                  {`${translate("Configure")}: ${configuration[0].product.name}`}
                </h6>
                {/* <span>
                  {configuration[0].product.description}
                </span> */}
                <span title = { getProductDescription(configuration[0].product,Culture_lang) }>{ getProductDescription(configuration[0].product,Culture_lang) }</span>
              </div>
              {PricingModule.showPrice( siteSettings.pricingModule ) && <div className='price-column'>
                <div className='row'>
                  <span>{translate('pricing including tax')}</span>
                  <ProductPrice showConfiguratorButtonAtTop={showConfiguratorButtonAtTop} fromConfigFooter fromCart={ false || fromCbol || apttusReconfig } priceSize='big' product={ { ...productList, configuration: template,FG: FG_Identified}  } fromSearch={this.props.fromSearch} />                 
                </div>
                
              </div>}
            </div>
            </BusyContainer>
            <Tab tabs={mobileTabs}></Tab>
            <FGcomponent
              FGDescription={configuration[0]?.product?.code?.startsWith('V')?configuration[0]?.product?.description:this.props.products[(this.state.configurationUpdated && !this.state.isConfigurationReset)|| !configuration[0].product.FG?this.getFG(configuration[0].product,supercode):configuration[0].product.FG]?.description}
              FG={(this.state.configurationUpdated && !this.state.isConfigurationReset)|| !configuration[0].product.FG?this.getFG(configuration[0].product,supercode):configuration[0].product.FG}
              showConfiguratorButtonAtTop={this.props.showConfiguratorButtonAtTop}
              user={this.props.user}
              isPopup={isPopup}
              template={template}
              products={ isPopup ? productList : cartProducts } 
              fromSearch={this.props.fromSearch}
              mobileView
              selectedOption={oldProduct?.deliveryOption || this.state.selectedOption}
              setSelectedOption = {this.setSelectedOption}
            />
        </Box>
    </div>
      <DialogContainer showConfirmation={ this.state.showConfirmation } toggleConfirmation={ this.toggleConfirmation } onLeave={ ()=>{this.leaveConfigurator()} } />
      {this.renderFooter(false, isPopup, productList, cartProducts, allMandatorySelectionsMade, 
        wiringDiagramDetailsCount, accessories.length, invalidVariables, requiredUnselectedVariables, 
        fromCart, oldProduct, template, assemblyType, supercode,supercodeAdditionalProduct, showConfiguratorButtonAtTop,configuration,accessories,inValidConfigurationMessage,isValidConfiguration)}
    </div></>
  }
}

ConfiguratorComponent.propTypes = {
  assignValue: PropTypes.func.isRequired,
  captureEvent: PropTypes.func.isRequired,
  className: PropTypes.string, 
  configuration: PropTypes.array,
  fromCart: PropTypes.bool, 
  isPopup: PropTypes.bool, 
  oldProduct: PropTypes.shape( {} ), 
  product: PropTypes.shape( {} ), 
  products: PropTypes.shape( {} ), 
  productModelType: PropTypes.number,
  removeValue: PropTypes.func.isRequired,
  resetConfiguration: PropTypes.func,
  screen: PropTypes.shape( {
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired
  } ),
  siteSettings: PropTypes.shape( {
    properties: PropTypes.shape( {
      isTestEnvironment: PropTypes.bool
    } )
  } )
};

ConfiguratorComponent.contextTypes = {
  properties: PropTypes.shape( { } )
};

ConfiguratorComponent.childContextTypes = {
  onAmountChange: PropTypes.func,
  onRemove: PropTypes.func
};

export const Configurator = connect( 
  combineStates( productState, screenState,screenSizeState, siteSettingsState, superCodeState, identityState, showConfigureState, flagState, currentPageState,priceState ), 
  combineDispatchers( activeTabDispatcher, analyticsDispatcher, superCodeDispatcher, showConfigureDispatcher, flagDispatcher, currentPageDispatcher,productsDispatcher,priceDispatcher  ) )( ConfiguratorComponent );